<div *ngIf="loading" class="loader">
  <div class="spinner"></div>
  <span>Loading more items...</span>
</div>
